export default __webpack_public_path__ + "static/media/full.243a48cf.svg";